// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ComplianceDataPrivacyService } from '@client/app/modules/data-privacy/services/compliance.dataprivacy.service';
import { ChangesHistoryService } from '@client/app/pages/global/changes-history/services/changes-history/changes-history.service';
import { DataPrivacyService } from '@client/app/modules/data-privacy/services/data-privacy/data-privacy.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { DataPrivacyInfoTypeRepoService } from '@client/app/modules/data-privacy/services/api/info-type/data-privacy-info-type-repo.service';
import { DataPrivacySummaryRepo } from '@client/app/modules/data-privacy/services/api/summary_repo';
import { CrawlsRepoService } from '@client/app/services/api/crawls-repo/crawls-repo.service';
import { DoughnutChart } from '@client/app/modules/charts/models/charts/doughnut';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { RISKS } from '@client/app/modules/data-privacy/constants/risks.constant';
import {
    PrivacyViolationPagesComponent,
} from '@client/app/modules/data-privacy/dialogs/violation-pages/privacy-violation-pages.component';

@Component({
    selector: 'privacy-summary',
    standalone: false,
    template: `
        <div id="data-privacy-summary">
            <page-header [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'ISSUES'] | monIcons" [header]="'Data Privacy Summary' | translate"
                         [subHeader]="'Scan your website for any data privacy issues that could be present' | translate">
                <page-header-content>
                    <div class="pt-1 pl-1 pull-right">
                        <csv-export-button clsSize="py-2 px-3" clsMargin="mr-0" [exports]="exports"></csv-export-button>
                    </div>
                </page-header-content>
            </page-header>
            <div class="row">
                <div class="col-48 col-md-24">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300 mb-1" translate>
                                Most serious issues found
                            </h2>
                            <span class="text-grey" translate>Most prominent issues ranked by severity level</span>
                        </div>
                        <div class="card-body">
                            <table-container [noResultMessage]="'Good job! No issues were found' | translate"
                                             [collection]="mostSevere"
                                             [progress]="progress"
                            >
                                <table class="table table-hover" *ngIf="infoTypes.length > 0">
                                    <thead>
                                    <tr>
                                        <th translate>Name</th>
                                        <th class="text-right text-v-middle" translate>Number of pages</th>
                                        <th class="text-right text-v-middle" translate>Severity level</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let infoType of mostSevere" >
                                        <td class="text-v-middle">
                                            {{infoType.name}}
                                        </td>
                                        <td class="text-right text-v-middle">
                                            <pages-button
                                                    *ngIf="getPagesWithActiveViolationCount(infoType) > 0 && infoType.info_type_domain_summary?.[0]"
                                                    (callback)="goToPages(infoType)"
                                                    [ngModel]="infoType.info_type_domain_summary[0].pages_with_active_violations_count"
                                                    name="pagesButton"></pages-button>
                                        </td>
                                        <td class="text-right text-v-middle">
                                            <mon-data-privacy-severity-level
                                                [monPriority]="infoType.priority"
                                                *ngIf="!loading">
                                            </mon-data-privacy-severity-level>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </table-container>
                        </div>
                    </div>
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300 mb-1" translate>
                                Affected pages by severity
                            </h2>
                            <span class="text-grey" translate>Distribution of Data Privacy levels</span>
                        </div>
                        <div class="card-body d-flex pl-0 pr-0">
                            <div class="flex-fill">
                                <mon-spinner [progress]="progress">
                                <div class="row">
                                    <div class="col-lg-24 col-md-48 mb-4 inline-block"
                                         *ngFor="let risk of risks">
                                        <div *ngIf="riskCounts">
                                        <div class="col-24 inline-block col-middle remove-float pr-0">
                                            <mon-chart-doughnut class="data-privacy-dashboard-doughnut"
                                                            [size]="'124'"
                                                            [colors]="chartColors"
                                                            [data]="doughnutRisks[risk.value]?.data"
                                                            [labels]="risksLabel"
                                                            [options]="doughnutRisks[risk.value]?.options">
                                            </mon-chart-doughnut>
                                        </div>
                                        <div class="col-23 inline-block col-middle remove-float">
                                            <div class="text-grey mb-1">
                                                <span class="fas fa-circle" [ngClass]="risk.value"></span>
                                                <span>{{ '[[name]] severity' | translate:'':{name: risk.name} }}</span>
                                            </div>
                                            <p class="mb-1">
                                                <span class="far fa-window-maximize text-turqoise pr-1"
                                                            aria-hidden="true"
                                                      [triggers]="'focus hover'"
                                                      [ngbTooltip]="'Fixed or ignored violations' | translate">
                                                </span>
                                                <strong>{{riskCounts[risk.value]?.total - riskCounts[risk.value]?.errors | monNumber}}</strong>
                                            </p>
                                            <p>
                                                <span class="far fa-window-maximize text-grey pr-1"
                                                            aria-hidden="true"
                                                      [triggers]="'focus hover'"
                                                      [ngbTooltip]="'Violations' | translate">
                                                </span>
                                                <strong>{{riskCounts[risk.value]?.errors | monNumber}}</strong>
                                            </p>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                </mon-spinner>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-48 col-md-24">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300 mb-1" translate>
                                Data Privacy Diagnostics
                            </h2>
                            <span class="text-grey" translate>
                                Percentage shows number of pages that are compliant with all Data Privacy checks
                            </span>
                        </div>
                        <div class="card-body mon-chart-dashboard">
                            <mon-spinner [progress]="progress">
                                <div class="row">
                                    <div class="offset-md-12 col-md-24 mt-6 mb-2">
                                        <mon-chart-doughnut *ngIf="!loading"
                                                        class="data-privacy-dashboard-doughnut"
                                                        [size]="'200'"
                                                        [colors]="chartColors"
                                                        [data]="doughnutDiagnosticsData"
                                                        [labels]="label"
                                                        [options]="doughnutDiagnosticsOptions">
                                        </mon-chart-doughnut>
                                    </div>
                                </div>
                                <div class="card-container">
                                    <ul class="pl-0 pr-0">
                                        <li>
                                            <p class="pl-2 my-0 text-grey">
                                                <span translate>
                                                    Data Privacy issues found
                                                </span>
                                                <span class="fas fa-question-circle"
                                                      [ngbTooltip]="'Contains issues with high, medium and low priority for all pages' | translate"
                                                      aria-hidden="false">
                                                </span>
                                            </p>
                                            <span class="pl-2 font-size-1-5 font-weight-400 card-count">
                                                {{
                                                    (summaryData?.violations_active_counts.high +
                                                summaryData?.violations_active_counts.medium +
                                                summaryData?.violations_active_counts.low) |
                                                    monNumber
                                                }}
                                            </span>
                                        </li>
                                        <li>
                                            <p class="pl-8 my-0 text-grey" translate>
                                                Pages with Data Privacy issues
                                            </p>
                                            <span class="pl-8 font-size-1-5 font-weight-400 card-count">
                                                {{summaryData?.pages_with_data_protection_violations_count | monNumber}}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="row">
                                    <div class="col-48">
                                        <privacy-history-line-chart [history]="history" *ngIf="!loading"></privacy-history-line-chart>
                                    </div>
                                </div>
                            </mon-spinner>
                        </div>
                        <div class="card-footer bg-white text-right" *ngIf="showHistory">
                            <a class="btn-link" [uiSref]="'base.customer.domain.changesHistory'" [uiParams]="historyCenterParameters"
                               monEventTrigger="actionTrigger"
                               [monEventParams]="{action:'go-to-history-center', from: 'data-privacy-summary'}"
                               translate>Show history</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PrivacySummaryComponent implements OnInit {
    historyCenterParameters: any = {};
    chartColors: any;
    infoTypes: any[] = [];
    summaryData: any = null;
    showHistory: any;
    risks: any;
    riskCounts: any = null;
    history: any[] = [];
    loading = false;
    label: any;
    risksLabel: any;
    mostSevere: any[] = [];
    exports: any;
    progress: any;
    doughnutDiagnosticsData: any;
    doughnutDiagnosticsOptions: any;
    doughnutRisks: any = {};

    constructor (
        private dataPrivacyInfoTypeRepoService: DataPrivacyInfoTypeRepoService,
        private dataPrivacySummaryRepo: DataPrivacySummaryRepo,
        private crawlsRepoService: CrawlsRepoService,
        private sessionService: SessionService,
        private monEventService: MonEventService,
        private pipeService: PipeService,
        private translateService: TranslateService,
        private complianceDataPrivacyService: ComplianceDataPrivacyService,
        private changesHistoryService: ChangesHistoryService,
        private dataPrivacyService: DataPrivacyService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        this.exports = [
            {
                name: this.translateService.getString('Data Privacy Summary Export'),
                data: {
                    category: 'data_protection_summary',
                },
            },
        ];
    }

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.historyCenterParameters = this.changesHistoryService.getHistoryCenterParameters('data-privacy');
        this.chartColors = ['#4dc0bd', '#dcdcdc'];
        this.infoTypes = [];
        this.summaryData = null;
        this.showHistory = this.activeFeatureService.isFeatureActivePure('history_center_all');
        this.risks = RISKS;
        this.riskCounts = null;
        this.history = [];
        this.loading = false;
        this.label = [this.translateService.getString('No violations were found'), this.translateService.getString('Content with violations')];
        this.risksLabel = [this.translateService.getString('Fixed or ignored violations'), this.translateService.getString('Violations')];
        this.mostSevere = [];

        this.getData();
    }

    getData () {
        this.loading = true;
        const promises = [
            this.dataPrivacyInfoTypeRepoService.getAllForDomain(String(this.sessionService.domain?.id || ''), { page_size: 0 }),
            this.dataPrivacySummaryRepo.getSummary(Number(this.sessionService.domain?.id || 0)),
            this.crawlsRepoService.getAll({ page_size: 5 }),
        ];
        this.progress = Promise
            .all(promises)
            .then((values: any) => {
                this.infoTypes = values[0];
                this.summaryData = values[1];
                this.history = values[2].reverse();
                this.riskCounts = {
                    low: this.getNumbers('low'),
                    medium: this.getNumbers('medium'),
                    high: this.getNumbers('high'),
                };

                this.setupDiagnosticsDoughnutChart(this.summaryData);
                this.setupSeverityDoughnutCharts(this.riskCounts);
                this.mostSevereInfoTypes();
            })
            .finally(() => {
                this.loading = false;
            });
    }

    mostSevereInfoTypes () {
        const priorities: any = { high: 2, medium: 1, low: 0 };
        if (this.infoTypes) {
            this.mostSevere = this.infoTypes
                .filter((type: any) => {
                    if (!type.info_type_domain_summary[0]) {
                        return false;
                    }
                    return this.getPagesWithActiveViolationCount(type) > 0;
                })
                .sort((a: any, b: any) => {
                    const firstPriority = priorities[a.priority];
                    const secondPriority = priorities[b.priority];
                    const firstViolationCount = this.getPagesWithActiveViolationCount(a);
                    const secondViolationCount = this.getPagesWithActiveViolationCount(b);

                    if (firstPriority === secondPriority) {
                        if (firstViolationCount > secondViolationCount) {
                            return -1;
                        } else if (firstViolationCount < secondViolationCount) {
                            return 1;
                        }
                        return 0;
                    }

                    if (firstPriority === undefined || secondPriority === undefined) {
                        return firstPriority === undefined ? 1 : -1;
                    }

                    if (firstPriority > secondPriority) {
                        return -1;
                    } else if (firstPriority < secondPriority) {
                        return 1;
                    }
                    return 0;
                })
                .slice(0, 5);
        }
    }

    getNumbers (risk: any) {
        const numbers = {
            errors: 0,
            total: 0,
        };

        this.infoTypes.filter((item: any) => item.priority === risk).forEach((infoType: any) => {
            if (infoType.info_type_domain_summary[0]) {
                numbers.errors += this.getPagesWithActiveViolationCount(infoType);
                numbers.total += this.getTotalPageCount(infoType);
            }
        });
        return numbers;
    }

    goToPages (infoType: any) {
        const params = {
            size: 'lg',
            body: PrivacyViolationPagesComponent,
            data: {
                infoType: infoType,
                totalPagesCount: this.getPagesWithActiveViolationCount(infoType),
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getData.bind(this) });
    }

    setupDiagnosticsDoughnutChart (summary: any) {
        const percentage = this.complianceDataPrivacyService.dataPrivacyCompliancePercentage(summary);
        this.doughnutDiagnosticsData = this.complianceDataPrivacyService.dataPrivacyCompliance(summary);
        this.doughnutDiagnosticsOptions = {
            cutoutPercentage: 80,
            centerText: {
                percentageLabel: this.pipeService.get('monNumber')(percentage / 100, '0.[00] %', null),
                totalLabel: this.translateService.getString('Data Privacy'),
                subLabel: this.translateService.getString('Compliance'),
                subFontSize: 170,
                totalFontSize: 170,
            },
            hover: {
                mode: null,
            },
        };
    }

    setupSeverityDoughnutCharts (riskCounts: any) {
        this.doughnutRisks = {};
        Object.keys(riskCounts).forEach((key: any) => {
            const errors = riskCounts[key].errors;
            let total = riskCounts[key].total - errors;
            total = total > 0 ? total : 1;
            this.doughnutRisks[key] = {
                data: [total, errors],
                options: this.getSeverityDoughnutOption(key, riskCounts),
            };
        });
    }

    getSeverityDoughnutOption (level: any, riskCounts: any) {
        const doughnutChart = new DoughnutChart();
        const compliant = riskCounts[level].total - riskCounts[level].errors;
        const total = riskCounts[level].total;
        let percentage;
        if (compliant === 0 && total === 0) {
            percentage = 100;
        } else {
            percentage = (compliant / total) * 100;
        }
        doughnutChart.setCutOutPercentage(80);
        doughnutChart.setCenterText(
            this.pipeService.get('monNumber')(percentage / 100, '0.[00] %', null),
            null,
            null,
        );
        doughnutChart.setTooltipSettings({
            enabled: true,
        });
        doughnutChart.setTooltipCustom({});
        return doughnutChart.options;
    }

    getPagesWithActiveViolationCount (infoType) {
        return this.dataPrivacyService.getPagesWithActiveViolationCount(infoType);
    }
    getTotalPageCount (infoType) {
        return this.dataPrivacyService.getTotalPageCount(infoType);
    };
}
